<template lang="pug">
//- The displayed text ("0:15") is an internal detail — the component's value is SECONDS. Stop the
//- native events here so a wrapping ValidationProvider doesn't capture the raw text via bubbling
//- and validate it (numeric would fail); it validates the bound `:model-value` instead.
div(
  @input.stop
  @change.stop
)
  AppInput(
    v-bind="$attrs"
    :value="formattedDuration"
    placeholder="0:00"
    @up="onUp"
    @down="onDown"
    @change="onChange"
  )
</template>

<script>
import { formatDuration } from '~/utils/time_utils';
import VModelCompat from '~/mixins/v_model_compat';

export default {
  name: 'WorkBreakPolicyDurationInput',
  mixins: [VModelCompat],
  // Attrs (e.g. the #duration id the e2e targets) belong on the inner AppInput, not the wrapper div.
  inheritAttrs: false,
  props: {
    modelValue: {
      required: false,
      default: undefined,
    },
  },
  emits: ['update:modelValue', 'input'],
  data() {
    return {
      currentValue: null,
    };
  },
  computed: {
    formattedDuration() {
      const formattedDuration = formatDuration(this.currentValue, { showSeconds: 'never' });

      return formattedDuration || this.currentValue;
    },
  },
  watch: {
    modelCompatValue(val) {
      this.currentValue = val;
    },
  },
  created() {
    this.currentValue = this.modelCompatValue;
  },
  methods: {
    emitValue(nextValue) {
      this.emitModelCompatValue(nextValue);
    },
    onUp() {
      this.emitValue(this.modelCompatValue.clone().add(1, 'minutes'));
    },
    onDown() {
      this.emitValue(this.modelCompatValue.clone().subtract(1, 'minutes'));
    },
    onChange(val) {
      const parsedDuration = TimeInput.parse_duration(val);

      if (parsedDuration) {
        this.currentValue = parsedDuration.asSeconds();
        this.emitValue(this.currentValue);
      } else {
        this.currentValue = val;
        this.emitValue(this.currentValue);
      }
    },
  },
};
</script>
